(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('orzein-sticky-variant')) {
    customElements.define('orzein-sticky-variant', class extends HTMLElement {
      connectedCallback() {
        const bind = () => {
          if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (String(data.sectionId) !== this.dataset.section) return;
            this.textContent = data.variant?.title || '';
            const sticky = this.closest('sticky-atc');
            const button = sticky?.querySelector('.main-product-atc');
            if (!button) return;
            const unavailable = !data.variant?.available || button.disabled;
            const longLabel = unavailable ? sticky.dataset.orzeinSoldOut : sticky.dataset.orzeinLongLabel;
            const shortLabel = unavailable ? sticky.dataset.orzeinSoldOut : sticky.dataset.orzeinShortLabel;
            const longElement = sticky.querySelector('.orzein-sticky__long-label');
            const shortElement = sticky.querySelector('.orzein-sticky__short-label');
            if (longElement) longElement.textContent = longLabel;
            if (shortElement) shortElement.textContent = shortLabel;
            button.setAttribute('aria-label', longLabel);
          });
        };
        if (document.readyState === 'loading') {
          this.onReady = bind;
          document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
        } else {
          bind();
        }
      }
      disconnectedCallback() {
        this.unsubscribe?.();
        if (this.onReady) document.removeEventListener('DOMContentLoaded', this.onReady);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
